import { sendPasswordResetEmail } from "firebase/auth"; // Import for password reset
import { signInWithEmailAndPassword } from "firebase/auth";
import React, { useState } from "react";
import { auth, db } from "../utils/firebase";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import SignInwithGoogle from "./signInWIthGoogle";
import { Link } from "react-router-dom";
import "../styles/Login.css";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [resetEmail, setResetEmail] = useState("");  // For password reset
  const [showResetModal, setShowResetModal] = useState(false);  // To toggle reset modal

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    setEmailError("");
    setPasswordError("");

    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      const userDoc = await getDoc(doc(db, "Users", user.uid));
      if (userDoc.exists()) {
        const userData = userDoc.data();
        const userRole = userData.role;

        if (userRole === "admin") {
          console.log("Admin logged in");
          navigate("/adminusers");
        } else {
          console.log("User logged in");
          navigate("/");
        }
      }
      console.log("User logged in Successfully");
      
      // Success toast with green color
      toast.success("Login Successful", {
        position: "top-center",
        autoClose: 500, // Automatically closes after 1 second
        style: {
          backgroundColor: '#4CAF50', // Green color for success
          color: 'white', // Text color white
        },
      });
    } catch (error) {
      console.log(error.message);

      if (error.message.includes("user-not-found")) {
        setEmailError("No user found with this email.");
      } else if (error.message.includes("wrong-password")) {
        setPasswordError("Incorrect password. Please try again.");
      } else {
        setPasswordError("Wrong username or password. Please try again.");
      }

      toast.error(error.message, {
        position: "bottom-center",
      });
    }

    setEmail("");
    setPassword("");
  };

  // Handle password reset
  const handlePasswordReset = async () => {
    if (!resetEmail) {
      toast.error("Please enter your email address.");
      return;
    }

    try {
      await sendPasswordResetEmail(auth, resetEmail);
      toast.success("Password reset email sent!", {
        position: "top-center",
      });
      setShowResetModal(false);  // Close modal after successful reset
      setResetEmail("");  // Clear the email input
    } catch (error) {
      console.error("Error sending password reset email:", error);
      toast.error("Failed to send password reset email. Please try again.");
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <h3>Login</h3>

      <div className="mb-3">
        <label>Email address</label>
        <input
          type="email"
          className="form-control"
          placeholder="Enter email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        {emailError && <div className="error-message">{emailError}</div>}
      </div>

      <div className="mb-3">
        <label>Password</label>
        <input
          type="password"
          className="form-control"
          placeholder="Enter password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        {passwordError && <div className="error-message">{passwordError}</div>}
      </div>

      <div className="d-grid">
        <button type="submit" className="btn btn-primary">
          Submit
        </button>
      </div>

      <p className="forgot-password text-right">
        New user <a href="/register">Register Here</a>
      </p>
      

      <p className="forgot-password text-right">
        <a href="#" onClick={() => setShowResetModal(true)}>
          Forgot Password?
        </a>
      </p>

      <SignInwithGoogle />

      <div className="return-home text-center mt-3">
      <Link to="/" className="return-link">
        <i className="bi bi-house-door me-2"></i>
        Return to Home
      </Link>
      </div>

      {/* Forgot Password Modal */}
      {showResetModal && (
        <div className="modal fade show" style={{ display: "block" }} tabIndex="-1" aria-labelledby="resetModalLabel" aria-hidden="true">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="resetModalLabel">Reset Password</h5>
                <button type="button" className="btn-close" onClick={() => setShowResetModal(false)}></button>
              </div>
              <div className="modal-body">
                <p>Please enter your email address to receive a password reset link.</p>
                <input
                  type="email"
                  className="form-control"
                  placeholder="Enter email"
                  value={resetEmail}
                  onChange={(e) => setResetEmail(e.target.value)}
                />
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowResetModal(false)}>
                  Close
                </button>
                <button type="button" className="btn btn-primary" onClick={handlePasswordReset}>
                  Send Reset Link
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </form>
  );
}

export default Login;
